import type { NodeViewProps } from "@tiptap/react";
import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";
import classNames from "classnames";
import Button from "../../../ui/Button/Button";
import { Close } from "../../../ui/Icon/Icon";
import styles from "./Symbol.module.css";

function Symbol({ deleteNode, node }: NodeViewProps) {
  if (node.content.size === 0) {
    return null;
  }

  return (
    <NodeViewWrapper
      as="span"
      className={classNames(styles.symbolNode, {
        [styles.symbolNodePurple]: node.attrs.color === "purple",
        [styles.symbolNodeGreen]: node.attrs.color === "green",
        [styles.symbolNodeBlue]: node.attrs.color === "blue",
        [styles.symbolNodeCyan]: node.attrs.color === "cyan",
      })}
    >
      <NodeViewContent as="span" />
      <Button
        className={styles.symbolDeleteButton}
        contentEditable={false}
        onClick={() => {
          deleteNode();
        }}
        variant="unstyled"
      >
        <Close size="xsmall" />
      </Button>
    </NodeViewWrapper>
  );
}

export default Symbol;
